var map = {
	"./Union.svg": "./src/assets/imgs/icons/Union.svg",
	"./activation-limit.svg": "./src/assets/imgs/icons/activation-limit.svg",
	"./application-record.svg": "./src/assets/imgs/icons/application-record.svg",
	"./back.svg": "./src/assets/imgs/icons/back.svg",
	"./borrow-money.svg": "./src/assets/imgs/icons/borrow-money.svg",
	"./bulb.svg": "./src/assets/imgs/icons/bulb.svg",
	"./check-circle.svg": "./src/assets/imgs/icons/check-circle.svg",
	"./close.svg": "./src/assets/imgs/icons/close.svg",
	"./fail-warn.svg": "./src/assets/imgs/icons/fail-warn.svg",
	"./gold.svg": "./src/assets/imgs/icons/gold.svg",
	"./home.svg": "./src/assets/imgs/icons/home.svg",
	"./icon-warn.svg": "./src/assets/imgs/icons/icon-warn.svg",
	"./immediate-withdrawal.svg": "./src/assets/imgs/icons/immediate-withdrawal.svg",
	"./input-phone.svg": "./src/assets/imgs/icons/input-phone.svg",
	"./lightning.svg": "./src/assets/imgs/icons/lightning.svg",
	"./lock.svg": "./src/assets/imgs/icons/lock.svg",
	"./money-collect.svg": "./src/assets/imgs/icons/money-collect.svg",
	"./my.svg": "./src/assets/imgs/icons/my.svg",
	"./personal-data.svg": "./src/assets/imgs/icons/personal-data.svg",
	"./purse.svg": "./src/assets/imgs/icons/purse.svg",
	"./rocket.svg": "./src/assets/imgs/icons/rocket.svg",
	"./safety.svg": "./src/assets/imgs/icons/safety.svg",
	"./sound.svg": "./src/assets/imgs/icons/sound.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs/icons sync \\.svg$";